import React, { Component } from 'react';
import { Button, Row, Col, Alert, InputGroup } from 'reactstrap';

import { InterpreterSignUpsForm } from './InterpreterSignUpsForm';
import { InterpreterSignUpsTableDefault } from './InterpreterSignUpsTableDefault';
import { InterpreterForm } from './InterpreterForm';
import { LoadingModal } from './LoadingModal';
import { FetchData, FetchFile } from './utils/DataFetch';
import { GetCookie, Timeout } from './utils/Common';
import { saveAs } from 'file-saver';

import AddIcon from '../images/add.png';

const normalizeString = (value) => String(value || '').trim().toLowerCase();
const normalizePhoneDigits = (value) => String(value || '').replace(/\D/g, '');

const getDefaultInterpreterModel = () => ({
  EventType: 'insert',
  IntId: null,
  IntLastName: '',
  IntFirstName: '',
  IntGender: '',
  IntPronoun: '',
  IntEmail: '',
  IntCellTxt: '',
  IntPhoneOnly: '',
  IntFax: '',
  IntBeeper: '',
  IntStreet: '',
  IntCity: '',
  IntState: '',
  IntZip: '',
  IntCountry: '',
  IntSSINumber: '',
  IntActiveFlg: true,
  IntCorporationFlg: false,
  DBA: '',
  InHouseFlg: false,
  UnVettedFlg: false,
  EmergencyContact: '',
  UnavailableReason: '',
  BankName: '',
  BankAccount: '',
  BankRoute: '',
  Rate: null,
  HourMinimum: null,
  Prorate: '',
  ConfCallRate: null,
  BusinessCardRequestDate: null,
  BusinessCardRequestToProcessFlg: false,
  IntNote: '',
  ReferredBy: '',
  DefaultLanguage: '',
  CreateDateTime: null,
  CreateByUserId: null,
  UpdateByUserId: null,
  UpdateDateTime: null,
  IsDeletedFlg: false,
  CreatedBy: '',
  UpdatedBy: '',
});

const mapSignUpToInterpreterModel = (signUpModel) => {
  const defaultModel = getDefaultInterpreterModel();
  const signUpId = signUpModel.IntSignUpId ?? signUpModel.intSignUpId ?? null;
  const firstName = signUpModel.IntFirstName ?? signUpModel.intFirstName ?? '';
  const lastName = signUpModel.IntLastName ?? signUpModel.intLastName ?? '';
  const email = signUpModel.IntEmail ?? signUpModel.intEmail ?? '';
  const phone = signUpModel.IntPhone ?? signUpModel.intPhone ?? '';
  const address =
    signUpModel.IntAddress ??
    signUpModel.intAddress ??
    signUpModel.IntStreet ??
    signUpModel.intStreet ??
    '';
  const city = signUpModel.IntCity ?? signUpModel.intCity ?? '';
  const state = signUpModel.IntState ?? signUpModel.intState ?? '';
  const zip = signUpModel.IntZip ?? signUpModel.intZip ?? '';

  return {
    ...defaultModel,
    IntFirstName: firstName,
    IntLastName: lastName,
    IntEmail: email,
    IntCellTxt: phone,
    IntPhoneOnly: phone,
    IntStreet: address,
    IntCity: city,
    IntState: state,
    IntZip: zip,
    IntNote: signUpId
      ? `Created from Interpreter Signup #${signUpId}`
      : defaultModel.IntNote,
  };
};

export class InterpreterSignUps extends Component {
  static displayName = InterpreterSignUps.name;

  constructor(props) {
    super(props);
    this.state = {
      signUpList: [],
      loading: false,
      fetchingData: false,
      modal: false,
      modalInterpreter: false,
      alert: {
        color: 'info',
        message: '',
        isOpen: false,
      },
      createdInterpreterId: null,
      interpreterModel: getDefaultInterpreterModel(),
      model: {
        EventType: 'insert',
        IntSignUpId: null,
        IntResumeFileName: '',
        IntSignUpDate: null,
        IntSignUpStatus: '',
        IntFirstName: '',
        IntLastName: '',
        IntEmail: '',
        IntPhone: '',
        IntAddress: '',
        IntCity: '',
        IntState: '',
        IntZip: '',
        IntLanguages: '',
        SubmittedAtUtc: null,
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
      searchModel: {
        Name: '',
        Email: '',
        Phone: '',
        Languages: '',
        Status: '',
        StartDate: '',
        EndDate: '',
        SortBy: 'submittedAtUtc',
        SortDirection: 'desc',
      },
    };
    this.user = JSON.parse(GetCookie('user'));

    this.setModal = this.setModal.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.renderInterpreterSignUpsTable =
      this.renderInterpreterSignUpsTable.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.setFetchingData = this.setFetchingData.bind(this);
    this.populateInterpreterSignUpsData =
      this.populateInterpreterSignUpsData.bind(this);
    this.mapSignUpRow = this.mapSignUpRow.bind(this);
    this.handleResumeDownload = this.handleResumeDownload.bind(this);
    this.setModalInterpreter = this.setModalInterpreter.bind(this);
    this.openInterpreterFromSignUp = this.openInterpreterFromSignUp.bind(this);
    this.handleSaveEventInterpreterSuccess =
      this.handleSaveEventInterpreterSuccess.bind(this);
    this.resolveCreatedInterpreterId =
      this.resolveCreatedInterpreterId.bind(this);
  }

  componentDidMount() {
    this.populateInterpreterSignUpsData();
  }

  setModal() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      createdInterpreterId: null,
    }));
  }

  setModalInterpreter() {
    this.setState((prevState) => ({
      modalInterpreter: !prevState.modalInterpreter,
    }));
  }

  resetFields() {
    this.setState(
      {
        model: {
          EventType: 'insert',
          IntSignUpId: null,
          IntResumeFileName: '',
          IntSignUpDate: null,
          IntSignUpStatus: '',
          IntFirstName: '',
          IntLastName: '',
          IntEmail: '',
          IntPhone: '',
          IntAddress: '',
          IntCity: '',
          IntState: '',
          IntZip: '',
          IntLanguages: '',
          SubmittedAtUtc: null,
          CreateDateTime: null,
          CreateByUserId: null,
          UpdateByUserId: null,
          UpdateDateTime: null,
          IsDeletedFlg: false,
        },
      },
      () => {
        this.setModal();
      },
    );
  }

  handleDoubleClick(signUpData) {
    const signup = signUpData.data;

    this.setState(
      {
        model: {
          EventType: 'update',
          IntSignUpId: signup.intSignUpId,
          IntResumeFileName: signup.intResumeFileName || '',
          IntSignUpDate: signup.intSignUpDate,
          IntSignUpStatus: signup.intSignUpStatus || '',
          IntFirstName: signup.intFirstName || '',
          IntLastName: signup.intLastName || '',
          IntEmail: signup.intEmail || '',
          IntPhone: signup.intPhone || '',
          IntAddress: signup.intAddress || '',
          IntCity: signup.intCity || '',
          IntState: signup.intState || '',
          IntZip: signup.intZip || '',
          IntLanguages: signup.intLanguages || '',
          SubmittedAtUtc: signup.submittedAtUtc,
          CreateDateTime: signup.createDateTime || null,
          CreateByUserId: signup.createByUserId || null,
          UpdateByUserId: signup.updateByUserId || null,
          UpdateDateTime: signup.updateDateTime || null,
          IsDeletedFlg: signup.isDeletedFlg || false,
        },
      },
      () => {
        this.setModal();
      },
    );
  }

  mapSignUpRow(signup) {
    return {
      intSignUpId: signup.intSignUpId ?? signup.IntSignUpId ?? null,
      intResumeFileName:
        signup.intResumeFileName ?? signup.IntResumeFileName ?? '',
      intSignUpDate: signup.intSignUpDate ?? signup.IntSignUpDate ?? null,
      intSignUpStatus: signup.intSignUpStatus ?? signup.IntSignUpStatus ?? '',
      intFirstName: signup.intFirstName ?? signup.IntFirstName ?? '',
      intLastName: signup.intLastName ?? signup.IntLastName ?? '',
      intEmail: signup.intEmail ?? signup.IntEmail ?? '',
      intPhone: signup.intPhone ?? signup.IntPhone ?? '',
      intAddress:
        signup.intAddress ??
        signup.IntAddress ??
        signup.intStreet ??
        signup.IntStreet ??
        '',
      intCity: signup.intCity ?? signup.IntCity ?? '',
      intState: signup.intState ?? signup.IntState ?? '',
      intZip: signup.intZip ?? signup.IntZip ?? '',
      intLanguages: signup.intLanguages ?? signup.IntLanguages ?? '',
      submittedAtUtc: signup.submittedAtUtc ?? signup.SubmittedAtUtc ?? null,
      createDateTime: signup.createDateTime ?? signup.CreateDateTime ?? null,
      createByUserId: signup.createByUserId ?? signup.CreateByUserId ?? null,
      updateByUserId: signup.updateByUserId ?? signup.UpdateByUserId ?? null,
      updateDateTime: signup.updateDateTime ?? signup.UpdateDateTime ?? null,
      isDeletedFlg: signup.isDeletedFlg ?? signup.IsDeletedFlg ?? false,
    };
  }

  openInterpreterFromSignUp(signUpModel) {
    this.setState({
      modal: true,
      modalInterpreter: true,
      interpreterModel: mapSignUpToInterpreterModel(signUpModel || {}),
      createdInterpreterId: null,
    });
  }

  async resolveCreatedInterpreterId(interpreterModel) {
    const existingInterpreterId =
      interpreterModel?.IntId ?? interpreterModel?.intId ?? null;
    if (existingInterpreterId !== null && existingInterpreterId !== '') {
      return existingInterpreterId;
    }

    const searchName =
      interpreterModel?.IntLastName && interpreterModel?.IntFirstName
        ? `${interpreterModel.IntLastName}, ${interpreterModel.IntFirstName}`
        : interpreterModel?.IntLastName || interpreterModel?.IntFirstName || '';

    const searchModel = {
      IntId: null,
      Name: searchName,
      Language: '',
      Phone: interpreterModel?.IntCellTxt || interpreterModel?.IntPhoneOnly || '',
      Email: interpreterModel?.IntEmail || '',
      City: '',
      State: '',
      Zip: '',
      ShowAll: false,
      UnVetted: false,
      SortBy: 'intLastName',
      SortDirection: 'asc',
    };

    const data = await FetchData(
      '/getinterpreters',
      'POST',
      this.user.token,
      searchModel,
    );

    if (!Array.isArray(data) || data.length === 0) {
      return null;
    }

    const targetFirstName = normalizeString(interpreterModel?.IntFirstName);
    const targetLastName = normalizeString(interpreterModel?.IntLastName);
    const targetEmail = normalizeString(interpreterModel?.IntEmail);
    const targetPhone = normalizePhoneDigits(
      interpreterModel?.IntCellTxt || interpreterModel?.IntPhoneOnly,
    );

    const exactMatches = data.filter((item) => {
      const firstNameMatches =
        !targetFirstName ||
        normalizeString(item.intFirstName) === targetFirstName;
      const lastNameMatches =
        !targetLastName || normalizeString(item.intLastName) === targetLastName;
      const emailMatches =
        !targetEmail || normalizeString(item.intEmail) === targetEmail;
      const phoneMatches =
        !targetPhone ||
        normalizePhoneDigits(item.intCellTxt) === targetPhone ||
        normalizePhoneDigits(item.intPhoneOnly) === targetPhone;

      return (
        firstNameMatches && lastNameMatches && emailMatches && phoneMatches
      );
    });

    const interpreterCandidates =
      exactMatches.length > 0 ? exactMatches : data.slice();

    interpreterCandidates.sort((a, b) => {
      const createDateTimeA = Date.parse(a.createDateTime || '') || 0;
      const createDateTimeB = Date.parse(b.createDateTime || '') || 0;
      if (createDateTimeA !== createDateTimeB) {
        return createDateTimeB - createDateTimeA;
      }

      const intIdA = Number(a.intId || 0);
      const intIdB = Number(b.intId || 0);
      return intIdB - intIdA;
    });

    return interpreterCandidates[0]?.intId ?? null;
  }

  async handleSaveEventInterpreterSuccess(alert) {
    let nextAlert = { ...alert };
    let createdInterpreterId = null;
    const isInsertSuccess =
      nextAlert &&
      nextAlert.model &&
      String(nextAlert.model.EventType || '').toLowerCase() === 'insert' &&
      String(nextAlert.message || '').toLowerCase() === 'success';

    if (isInsertSuccess) {
      this.setState({ fetchingData: true });

      try {
        createdInterpreterId = await this.resolveCreatedInterpreterId(
          nextAlert.model,
        );

        if (!createdInterpreterId) {
          nextAlert = {
            ...nextAlert,
            color: 'warning',
            message:
              'Interpreter was created, but the new interpreter ID could not be resolved.',
          };
        }
      } catch (error) {
        console.error('Failed to resolve interpreter ID from signup flow.', error);
        nextAlert = {
          ...nextAlert,
          color: 'warning',
          message:
            'Interpreter was created, but there was an error retrieving the new interpreter ID.',
        };
      } finally {
        this.setState({ fetchingData: false });
      }
    }

    this.setState(
      {
        modalInterpreter: nextAlert.modal,
        createdInterpreterId,
        alert: {
          color: nextAlert.color,
          message: nextAlert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState((prevState) => ({
            alert: {
              ...prevState.alert,
              isOpen: false,
            },
          }));
        }, Timeout(nextAlert.message));
      },
    );
  }

  async handleResumeDownload(fullResumeFileName, displayResumeFileName) {
    if (!fullResumeFileName) return;

    this.setState({ fetchingData: true });

    try {
      const fileResponse = await FetchFile(
        '/getinterpretersignupresume',
        'POST',
        this.user.token,
        {
          IntResumeFileName: fullResumeFileName,
          intResumeFileName: fullResumeFileName,
        },
        { includeMeta: true },
      );

      const responseContentType = fileResponse.contentType || '';
      const isPdfResponse =
        fileResponse.status === 200 &&
        fileResponse.ok &&
        responseContentType.includes('application/pdf');

      if (!isPdfResponse) {
        let errorMessage = '';
        const isLikelyTextResponse =
          responseContentType.includes('application/json') ||
          responseContentType.includes('text/') ||
          responseContentType.includes('application/problem+json');

        try {
          if (isLikelyTextResponse) {
            const responseBodyText = await fileResponse.blob.text();

            if (responseContentType.includes('application/json')) {
              const errorData = JSON.parse(responseBodyText || '{}');
              if (typeof errorData === 'string') {
                errorMessage = errorData;
              } else {
                errorMessage =
                  errorData?.message ||
                  errorData?.Message ||
                  errorData?.error ||
                  '';
              }
            } else {
              errorMessage = responseBodyText;
            }
          }
        } catch (readError) {
          errorMessage = '';
        }

        if (!errorMessage) {
          const receivedType = responseContentType || 'unknown';
          if (fileResponse.status === 200) {
            errorMessage = `Resume download failed. Expected application/pdf but received ${receivedType}.`;
          } else {
            errorMessage = `Resume download failed (HTTP ${fileResponse.status}, ${receivedType}).`;
          }
        }

        this.setState(
          {
            alert: {
              color: 'warning',
              message: errorMessage,
              isOpen: true,
            },
          },
          () => {
            window.setTimeout(() => {
              this.setState((prevState) => ({
                alert: {
                  ...prevState.alert,
                  isOpen: false,
                },
              }));
            }, Timeout(errorMessage));
          },
        );
        return;
      }

      const fallbackFileName = 'InterpreterResume.pdf';
      if (!fileResponse.blob || fileResponse.blob.size === 0) {
        this.setState(
          { alert: { color: 'warning', message: 'No file returned.', isOpen: true } },
          () => { window.setTimeout(() => this.setState((prevState) => ({ alert: { ...prevState.alert, isOpen: false } })), Timeout('No file returned.')); }
        );
        return;
      }
      saveAs(
        fileResponse.blob,
        displayResumeFileName || fullResumeFileName || fallbackFileName,
      );
    } catch (error) {
      console.error('Failed to download interpreter signup resume.', error);
      this.setState(
        {
          alert: {
            color: 'warning',
            message: 'Unable to download resume file.',
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState((prevState) => ({
              alert: {
                ...prevState.alert,
                isOpen: false,
              },
            }));
          }, Timeout('Unable to download resume file.'));
        },
      );
    } finally {
      this.setState({ fetchingData: false });
    }
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState((prevState) => ({
            alert: {
              ...prevState.alert,
              isOpen: false,
            },
          }));
        }, Timeout(alert.message));

        if (alert.model && alert.model.EventType === 'insert') {
          this.setState(
            {
              searchModel: {
                ...this.state.searchModel,
                Name: alert.model.IntLastName || '',
              },
            },
            () => {
              this.populateInterpreterSignUpsData();
            },
          );
        } else {
          this.populateInterpreterSignUpsData();
        }
      },
    );
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    if (e.target.type === 'checkbox') model[e.target.name] = e.target.checked;
    else model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.populateInterpreterSignUpsData();
    }
  }

  setFetchingData(fetching) {
    this.setState({ fetchingData: fetching });
  }

  async populateInterpreterSignUpsData() {
    this.setState({ fetchingData: true });

    FetchData(
      '/getinterpretersignups',
      'POST',
      this.user.token,
      this.state.searchModel,
    ).then((data) => {
      const rows = Array.isArray(data)
        ? data.map((item) => this.mapSignUpRow(item))
        : [];
      this.setState({
        signUpList: rows,
        loading: false,
        fetchingData: false,
      });
    });
  }

  renderInterpreterSignUpsTable() {
    return (
      <InterpreterSignUpsTableDefault
        signUps={this.state.signUpList}
        handleDoubleClick={this.handleDoubleClick}
        handleResumeDownload={this.handleResumeDownload}
      />
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderInterpreterSignUpsTable()
    );

    return (
      <div style={{ paddingTop: '12px' }}>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tableLabel">Interpreter Signups</h5>
        <Row>
          <Col>
            <InputGroup size="sm">
              <Button color="btn" onClick={this.resetFields} size="sm">
                <img
                  src={AddIcon}
                  style={{ width: '16px', height: '16px' }}
                  alt="Add"
                />{' '}
                New
              </Button>
              <input
                name="Name"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Name}
                onChange={this.handleSearchChange}
                placeholder="Name (Lastname, Firstname)"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Email"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Email}
                onChange={this.handleSearchChange}
                placeholder="Email"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Phone"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Phone}
                onChange={this.handleSearchChange}
                placeholder="Phone"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Languages"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Languages}
                onChange={this.handleSearchChange}
                placeholder="Languages"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Status"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Status}
                onChange={this.handleSearchChange}
                placeholder="Status"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="StartDate"
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.StartDate}
                onChange={this.handleSearchChange}
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="EndDate"
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.EndDate}
                onChange={this.handleSearchChange}
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <LoadingModal fetchingData={this.state.fetchingData} />

        {this.state.modal && (
          <InterpreterSignUpsForm
            model={this.state.model}
            modal={this.state.modal}
            modalInterpreter={this.state.modalInterpreter}
            alert={this.state.alert}
            setModal={this.setModal}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
            setFetchingData={this.setFetchingData}
            handleResumeDownload={this.handleResumeDownload}
            handleOpenInterpreterForm={this.openInterpreterFromSignUp}
            createdInterpreterId={this.state.createdInterpreterId}
          />
        )}
        {this.state.modalInterpreter && (
          <InterpreterForm
            model={this.state.interpreterModel}
            modal={this.state.modalInterpreter}
            alert={this.state.alert}
            setModal={this.setModalInterpreter}
            handleSaveEventSuccess={this.handleSaveEventInterpreterSuccess}
          />
        )}

        <div>{contents}</div>
      </div>
    );
  }
}
